module.exports = __webpack_public_path__ + "img/college.cced6b4b.png";